import * as React from "react";
function SvgTick(props) {
  return <svg width={288} height={288} viewBox="0 0 288 288" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><rect width={288} height={288} rx={144} fill="#FC5715" /><line x1={72.5313} y1={139.033} x2={125.531} y2={195.033} stroke="white" strokeWidth={29} /><line x1={111.504} y1={187.043} x2={216.504} y2={96.0425} stroke="white" strokeWidth={29} /></svg>;
}
export default SvgTick;